module.exports = __webpack_public_path__ + "static/media/ic-drag-and-drop.472bebc5.svg";